<t4-header icon="glyphicon-stats"></t4-header>
<h1>{{ 'Turbo.OneWayAdmin.ClaimStatistics.Headline' | translate:'Claim statistics'}}</h1>
<t4-periodPicker [(from)]="fromDate" [(to)]="toDate" (periodChanged)="loadData()"></t4-periodPicker>
<t4-container>
  <t4-data-table matSortActive="ClosedAt" [rawData]="claims" headline="" matSort [filterFields]="['ClaimId', 'Trailer', 'Location', 'Country', 'ServiceLocationName']" [autoGenerateColumns]="false">

    <ng-container matColumnDef="ClaimId">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Claims.lblClaimId' | translate:'Claim Id'}}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex: 0 0 100px;">{{ row.ClaimId }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Trailer">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObjectId">{{ row.Trailer }}</t4-object-link></mat-cell>
    </ng-container>

    <ng-container matColumnDef="Location">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblLocation' | translate:'Location'}}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Location }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Country">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex: 0 0 100px;">{{ row.Country }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="ServiceLocationName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblServiceLocation' | translate:'Service location'}}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.ServiceLocationName }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="ClosedAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.ClaimStatistics.lblClosedAt' | translate:'Closed at'}}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex: 0 0 100px;">{{ row.ClosedAt | date : 'yyMMdd' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="NewMinutes">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 120px;">{{ 'Turbo.OneWayAdmin.Claims.headNew' | translate:'New'}}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex: 0 0 120px;">{{ row.NewMinutes }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="WaitingForDecisionMinutes">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 120px;">{{ 'Turbo.OneWayAdmin.Claims.headWaitingForDecision' | translate:'Waiting for decision'}}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex: 0 0 120px;">{{ row.WaitingForDecisionMinutes}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="WaitingForSparePartMinutes">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 120px;">{{ 'Turbo.OneWayAdmin.Claims.headWaitingForSpareParts' | translate:'Waiting for spare part'}}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex: 0 0 120px;">{{ row.WaitingForSparePartMinutes }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="WaitingForServiceMinutes">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 120px;">{{ 'Turbo.OneWayAdmin.Claims.headWaitingForService' | translate:'Waiting for service'}}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="flex: 0 0 120px;">{{ row.WaitingForServiceMinutes }}</mat-cell>
    </ng-container>

  </t4-data-table>
</t4-container>
